import React, { useContext } from "react";

import {
  useTokenizedLinkSignup,
  usePreBillHeapEvent,
} from "@app/preBill/hooks";
import { AccountInfoBox } from "@app/preBill/components/accountInfoBox";
import { FAQInfoText } from "@app/preBill/components/faqInfoText";
import { WhatsNextSection } from "@app/preBill/components/whatNextSection";
import { SurveySection } from "@app/preBill/components/surveySection";
import { NoLongerAvailableCard } from "@app/preBill/components/noLongerAvailableCard";
import { UserContext } from "@app/provider";
import { HEAP_EVENTS } from "@app/provider/types";

import "./../../../preBill.scss";

const InsuranceNoLongerAvailable: React.FC = () => {
  const { uppUser } = useContext(UserContext);
  const { redirectToTokenizedSignup, isLoading } = useTokenizedLinkSignup();
  const { trackPreBillHeapEvent } = usePreBillHeapEvent();

  const handleClickCreateAccount = async (): Promise<void> => {
    trackPreBillHeapEvent({
      eventKey: HEAP_EVENTS.upp_pb_click_create_account,
    });
    redirectToTokenizedSignup();
  };

  return (
    <>
      <div className="insurance-no-longer-available-page">
        <NoLongerAvailableCard />
        <div className="insurance-no-longer-available-page__divider" />
        <WhatsNextSection />
        <SurveySection />
        {!uppUser && (
          <AccountInfoBox
            createAccountButtonAction={handleClickCreateAccount}
            isLoading={isLoading}
          />
        )}
        <FAQInfoText />
      </div>
    </>
  );
};

export default InsuranceNoLongerAvailable;
